module.exports = __webpack_public_path__ + "assets/img/out_(4).43d4b955.gif";